export const getBatches = ({ answerVariants, trait, traitValues }) =>
  answerVariants.map(av => {
    const batch = {
      position: av.position,
      text: av.text,
      fixed: false
    }

    if (trait) {
      batch.answerVariants = []

      traitValues.forEach((traitValue, idx) => {
        batch.answerVariants.push({
          position: idx * 3 + 1,
          text: `Purchased, ${traitValue.name}`,
          fixed: false,
          positive: true,
          score: idx * 3 + 1
        })
        batch.answerVariants.push({
          position: idx * 3 + 2,
          text: `Picked up only, ${traitValue.name}`,
          fixed: false,
          positive: true,
          score: idx * 3 + 2
        })
        batch.answerVariants.push({
          position: idx * 3 + 3,
          text: `No action, ${traitValue.name}`,
          fixed: false,
          positive: true,
          score: idx * 3 + 3
        })
      })
    } else {
      batch.answerVariants = [
        { position: 1, text: 'Purchased', fixed: false, positive: true, score: 1 },
        { position: 2, text: 'Picked up only', fixed: false, positive: true, score: 2 },
        { position: 3, text: 'No action', fixed: false, positive: true, score: 3 }
      ]
    }

    return batch
  })
